var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChatRoomOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icChatRoomOrange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.956862745   0 0 0 0 0.68627451   0 0 0 0 0.00392156863  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium-upgrade",
    transform: "translate(-9.000000, -1123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 908.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icChatRoomOrange",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "menuIcon-1-04",
    transform: "translate(13.000000, 13.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7784,0.5616 C21.0220198,0.552003882 22.2180028,1.03931718 23.1007741,1.91532916 C23.9835455,2.79134114 24.48,3.98354321 24.48,5.2272 L24.48,5.2272 L24.48,16.1424 C24.48,17.3867712 23.9851847,18.5800713 23.1046063,19.4592991 C22.2240279,20.3385269 21.0299697,20.8315115 19.7856,20.8296 L19.7856,20.8296 L6.0048,20.8296 C5.83781152,20.9587117 5.67909895,21.0981864 5.5296,21.2472 L5.5296,21.2472 L5.2704,21.4776 L1.6704,24.7176 C1.37986545,24.9793479 0.9634901,25.0478998 0.604376891,24.8931096 C0.245263683,24.7383194 0.00920159346,24.3885445 0,23.9976 L0,23.9976 L0,5.2272 C0.0316298453,2.62140986 2.16776833,0.533600305 4.7736,0.5616 L4.7736,0.5616 Z",
    id: "Shape",
    fill: "#F4AF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4464,6.5952 L15.4368,8.5464 L15.4368,7.956 C15.4368,7.16070996 14.79209,6.516 13.9968,6.516 L6.9048,6.516 C6.10950996,6.516 5.4648,7.16070996 5.4648,7.956 L5.4648,13.716 C5.4648,14.51129 6.10950996,15.156 6.9048,15.156 L14.0184,15.156 C14.81369,15.156 15.4584,14.51129 15.4584,13.716 L15.4584,13.1256 L18.468,15.0768 C18.5783602,15.1440028 18.7162716,15.1469067 18.8293628,15.0844089 C18.942454,15.0219111 19.0133774,14.9035986 19.0152,14.7744 L19.0152,6.8832 C19.0332538,6.74122991 18.9600469,6.60325266 18.8323672,6.53860474 C18.7046876,6.47395681 18.5501448,6.49661777 18.4464,6.5952 L18.4464,6.5952 Z M14.4,13.392 C14.3981009,13.5657732 14.3272431,13.7316734 14.2030167,13.8531992 C14.0787903,13.9747251 13.9113729,14.0419201 13.7376,14.04004 L7.1424,14.04004 C6.96862705,14.0419201 6.80120974,13.9747251 6.67698335,13.8531992 C6.55275695,13.7316734 6.4818991,13.5657732 6.48,13.392 L6.48,8.244 C6.48787022,7.88496084 6.78329724,7.59916732 7.1424,7.60315784 L13.7376,7.60315784 C14.0967028,7.59916732 14.3921298,7.88496084 14.4,8.244 L14.4,13.392 Z M18,13.7232 L15.3288,12.0888 L15.3288,9.5544 L18,7.92 L18,13.7232 Z",
    id: "Video_Camera",
    fill: "#FFFFFF"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatRoomOrange);
export default __webpack_public_path__ + "static/media/icChatRoomOrange.394b95f901aa6c04dafaa07cba3d3032.svg";
export { ForwardRef as ReactComponent };